export const fileToBase64 = (file: Blob) =>
  new Promise<string>((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = () => resolve(reader.result as string)
    reader.onerror = reject
    reader.readAsDataURL(file)
  })

export const getImageData = (data, onLoad) => {
  const img = new Image()

  img.onload = () => {
    onLoad({
      width: img.width,
      height: img.height,
    })
  }

  img.src = data
}

export const getImageFromFile = (file: Blob, onload) => {
  const reader = new FileReader()
  reader.readAsDataURL(file)
  reader.onload = () => {
    const img = new Image()

    img.onload = () => {
      onload({
        src: reader.result,
        width: img.width,
        height: img.height,
      })
    }

    img.src = reader.result as string
  }
  reader.onerror = function (error) {
    console.log("Error: ", error)
  }
}

export const getFileInfo = (url) => {
  const parsedUrl = new URL(url)
  const path = parsedUrl.pathname
  const fileNameWithExtension = path.split("/").pop()
  const fileParts = fileNameWithExtension.split(".")

  const type = fileParts.pop()
  const name = fileParts.join(".")

  return {
    name,
    type,
  }
}
